<template>
  <div>
    <h2 class="text-left alert" :class="[ removed ? 'alert-danger' : 'alert-success' ]">
      Forecast Lepto Program
      <a class="btn btn-sm" @click="$emit('onRemoveSection', stepName)">
        <span class="glyphicon" :class="[ removed ? 'glyphicon-plus' : 'glyphicon-remove' ]"></span>
      </a>
    </h2>

    <h3 class="text-left" :class="isRemovedSubsection('lepto_products_purchased') ? 'comment-disabled' : ''">
      <u>Lepto Products Purchased</u>
      <a class="btn btn-sm" @click="$emit('onRemoveSection', stepName, 'lepto_products_purchased')">
        <span class="glyphicon" :class="isRemovedSubsection('lepto_products_purchased') ? 'glyphicon-plus' : 'glyphicon-remove'"></span>
      </a>
    </h3>
    <div v-if="model.CHARTS.sr_lepto_purchases.length > 0 ">
      <table class="table table-bordered">
        <thead>
          <tr>
            <th>Purchase Date</th>
            <th>Farm</th>
            <th>Stock Code - Name</th>
            <th>Quantity</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(lp, index) in model.CHARTS.sr_lepto_purchases" :key="index">
            <td class="text-left">{{ lp[0] }}</td>
            <td class="text-left">{{ lp[1] }}</td>
            <td class="text-left">{{ lp[2] }}</td>
            <td class="text-left">{{ lp[3] }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-else>
      <p class="text-left">No Results</p>
    </div>

    <h3 class="text-left" :class="isRemovedSubsection('lepto_vaccination') ? 'comment-disabled' : ''">
      <u>Lepto Vaccination details from Winter Consult</u>
      <a class="btn btn-sm" @click="$emit('onRemoveSection', stepName, 'lepto_vaccination')">
        <span class="glyphicon" :class="isRemovedSubsection('lepto_vaccination') ? 'glyphicon-plus' : 'glyphicon-remove'"></span>
      </a>
    </h3>
    <div v-for="farm in model.FARMS" :key="'lepto_vacc_'+farm.id">
      <h4 class="text-left"> {{ farm.farm_label }} </h4>

      <dl class="dl-horizontal">
        <dt>First Vax Date</dt>
        <dd class="dd-multiple-farms">{{ model.previous_winter_consult[`farm_${farm.id}-lepto_calves_date_1`] || '-'}}</dd>

        <dt>Second Vax Date</dt>
        <dd class="dd-multiple-farms">{{ model.previous_winter_consult[`farm_${farm.id}-lepto_calves_date_2`] || '-'}}</dd>

        <dt>Third Vax Date</dt>
        <dd class="dd-multiple-farms">{{ model.previous_winter_consult[`farm_${farm.id}-lepto_calves_date_3`] || '-'}}</dd>

        <dt>Heifers Vax Date</dt>
        <dd class="dd-multiple-farms">{{ model.previous_winter_consult[`farm_${farm.id}-lepto_heifers_date`] || '-'}}</dd>

        <dt>Herd Vax Date</dt>
        <dd class="dd-multiple-farms">{{ model.previous_winter_consult[`farm_${farm.id}-lepto_herd_date`] || '-'}}</dd>

        <dt>Programme Type?</dt>
        <dd class="dd-multiple-farms">{{ model.previous_winter_consult[`farm_${farm.id}-lepto_vax_program`] || '-'}}</dd>

        <dt>Vaccination Completed in?</dt>
        <dd class="dd-multiple-farms">{{ model.previous_winter_consult[`farm_${farm.id}-lepto_vax_completed_in`] || '-'}}</dd>

        <dt>Numbers of Pigs on Farm?</dt>
        <dd class="dd-multiple-farms">{{ model.previous_winter_consult[`farm_${farm.id}-pigs_on_farm`] || '-'}}</dd>
      </dl>
    </div>

    <template v-if="!removed">
      <div class="text-left step-section">
        <dl class="dl-horizontal">
          <dt>Do you need 7 in 1 / lepto?</dt>
          <dd>{{ model.wants_lepto || '-'}}</dd>

          <dt>Product</dt>
          <dd>{{ model.lepto_product|| '-'}}</dd>

          <dt>Doses</dt>
          <dd>{{ model.lepto_doses|| '-'}}</dd>

          <dt>Needle</dt>
          <dd>{{ model.lepto_needle|| '-'}}</dd>

          <dt>Guns</dt>
          <dd>{{ model.lepto_guns|| '-'}}</dd>

          <dt>Pick up/ Delivery</dt>
          <dd>{{ model.lepto_delivery|| '-'}}</dd>
        </dl>
        <dl class="dl-horizontal">
          <dt>Do you want drench?</dt>
          <dd>{{ model.wants_drench || '-'}}</dd>

          <dt>Product</dt>
          <dd>{{ model.drench_product|| '-'}}</dd>

          <dt>Doses</dt>
          <dd>{{ model.drench_doses|| '-'}}</dd>

          <dt>Needle</dt>
          <dd>{{ model.drench_needle|| '-'}}</dd>

          <dt>Guns</dt>
          <dd>{{ model.drench_guns|| '-'}}</dd>

          <dt>Pick up/ Delivery</dt>
          <dd>{{ model.drench_delivery|| '-'}}</dd>
        </dl>
        <dl class="dl-horizontal">
          <dt>Do you require trace elements?</dt>
          <dd>{{ model.wants_te || '-'}}</dd>

          <dt>Product</dt>
          <dd>{{ model.te_product|| '-'}}</dd>

          <dt>Doses</dt>
          <dd>{{ model.te_doses|| '-'}}</dd>

          <dt>Needle</dt>
          <dd>{{ model.te_needle|| '-'}}</dd>

          <dt>Guns</dt>
          <dd>{{ model.te_guns|| '-'}}</dd>

          <dt>Pick up/ Delivery</dt>
          <dd>{{ model.te_delivery|| '-'}}</dd>
        </dl>
      </div>
    </template>
  </div>
</template>

<script>
import mixin from './mixin'

export default {
  mixins: [ mixin ],
  props: ['model'],
  data() {
    return {
      stepName: 'ForecastLepto',
    }
  },
};
</script>
